import { useColorModeValue } from '@chakra-ui/react';

export const useFontErrorColor = () => {
  return useColorModeValue('text.light.error', 'text.dark.error');
};
